/* eslint-disable */
// /src/pages/NoticeDetailPage.jsx  (사용자용 공지 상세)
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import PageTopBar from "../components/PageTopBar";
import { getNotice } from "../services/announcementsPublicService";

const Wrap = styled.div`min-height:100vh;background:linear-gradient(180deg,#D7E8FF 0%, #EAF3FF 100%);display:flex;flex-direction:column;`;
const Sheet = styled.div`background:#F7FAFF;box-shadow:0 -4px 20px rgba(0,0,0,.05);min-height:100dvh;display:flex;flex-direction:column;`;
const Body = styled.div`flex:1;padding:16px;display:grid;grid-template-rows:auto 1fr auto;row-gap:14px;`;
const Article = styled.article`
  background:#fff;border-radius:16px;box-shadow:0 1px 10px rgba(0,0,0,.06);padding:16px 14px;overflow:hidden;
`;
const Title = styled.h1`margin:0 0 6px;font-size:18px;font-weight:900;color:#0f172a;`;
const Meta = styled.div`font-size:12px;color:#64748b;margin-bottom:10px;`;
const Cover = styled.img`width:100%;height:auto;border-radius:10px;margin:8px 0 12px;`;
const Content = styled.div`
  color:#0f172a;line-height:1.65;font-size:14px;
  /* 안전 최소 스타일 */
  img{max-width:100%;height:auto;border-radius:8px}
  h1,h2,h3{margin:.8em 0 .4em}
  p{margin:.4em 0}
  ul{padding-left:18px}
`;

const BottomPad = styled.div`height:max(24px, env(safe-area-inset-bottom));`;

function fmt(d) { try { return (d instanceof Date ? d : new Date(d)).toISOString().slice(0, 10); } catch { return "-"; } }

export default function NoticeDetailPage() {
    const { id } = useParams();
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const v = await getNotice(id);
                setDoc(v);
            } finally { setLoading(false); }
        })();
    }, [id]);

    return (
        <Wrap>
            <Sheet>
                <PageTopBar variant="back" label="뒤로" />

                <Body>


                    <Article>
                        {loading && <div style={{ padding: 12, color: "#64748b" }}>불러오는 중…</div>}
                        {!loading && !doc && <div style={{ padding: 12, color: "#b91c1c" }}>해당 공지를 찾을 수 없습니다.</div>}

                        {!loading && doc && (
                            <>
                                <Title>{doc.title}</Title>
                                <Meta>{fmt(doc.publishedAt)}</Meta>
                                {doc.imageUrl ? <Cover src={doc.imageUrl} alt="" /> : null}
                                <Content dangerouslySetInnerHTML={{ __html: doc.bodyHtml || "" }} />
                            </>
                        )}
                    </Article>

                    <BottomPad />
                </Body>
            </Sheet>
        </Wrap>
    );
}
